import React from 'react';
import FullWidthBarBreadcrumbs from '@/components/Breadcrumb/FullWidthBarBreadcrumbs';
import CenteredContentSection from '@/components/ContentSection/CenteredContentSection';
import { H3 } from '@/components/Element/Heading';
import MetaTags from '@/components/Head/MetaTags';
// import SimpleCenteredHeaderSection from '@/components/HeaderSection/SimpleCenteredHeaderSection';

import SideCardCTA from '@/components/SideCardCTA/SideCardCTA2';
import Link from 'next/link';
import FullWidthGuideFormSection from '@/components/LeadForm/FullWidthGuideForm';
import { SolarGuideTable } from './why-go-solar';

const Page = () => {
  return (
    <article>
      <MetaTags
        title="Finding Reputable Solar and Battery Installers"
        description="2023 Solar Guide"
      />
      <FullWidthBarBreadcrumbs
        pages={[
          {
            name: 'Home Solar Guide',
            href: '/home-solar-guide',
          },
          {
            name: 'Getting Started With Home Solar',
            href: '/home-solar-guide/getting-started',
          },
        ]}
      />

      <CenteredContentSection>
        <div className="flex justify-between items-center">
          <Link
            href={
              '/home-solar-guide/finding-reputable-solar-and-battery-installers'
            }
          >
            ← Finding Reputable Solar and Battery Installers
          </Link>{' '}
          <div></div>
        </div>
        <H3>Getting Started With Home Solar 🌞</H3>
        <p>
          We know that the journey towards transitioning to solar energy can
          sometimes seem complicated, with numerous considerations to navigate.
          It&apos;s a world full of varied solar panels, intricate energy
          storage systems, and financial considerations.
        </p>
        <p>
          <strong>
            Think of us as your personal guides on this solar journey.
          </strong>{' '}
          Our dedicated Energy Advisors are here to ease the process for you.
          They&apos;ll explain all the complex parts, help you understand the
          various choices you have, and assist you in making decisions that suit
          your needs and circumstances best.
        </p>
        <p>
          And the best part? This personalized guidance service is completely
          free. We&apos;re driven by our mission to help more and more
          households harness the power of the sun.
        </p>
        <p>
          So, let&apos;s take this important step together. Reach out to our
          Energy Advisors and let us guide you to a brighter, more sustainable,
          and energy-efficient future. We&apos;re excited to help you every step
          of the way, turning the seemingly complex world of solar energy into
          an easy and rewarding experience.
        </p>
      </CenteredContentSection>
      <SideCardCTA />
      <FullWidthGuideFormSection cid={'a4oqmxxt5un31ha0'} />
      <SolarGuideTable />
    </article>
  );
};

export default Page;
